import React, { Component } from 'react';
import { translate } from 'react-i18next';
import moment from 'moment';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import { print } from 'react-icons-kit/fa/print';

import { lookups, petitionsApheresisValues, petitionMedicalNotesGet, petitionMedicalNotesPost, medicalNotes, donationsDonorInfo, monitoringMedicalNotes, monitoringMedicalNotesSave, donorHcData, offeringMedicalNotes, offeringMedicalNotesSave } from '../../libs/services';

import Help from '../../containers/generics/help';
import BreadcrumbTitle from '../../components/BreadcrumbTitle';
import ButtonForm from '../../components/ButtonForm';

class MedicalNotes extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.changeNotes = this.changeNotes.bind(this);
        this.reset = this.reset.bind(this);
        this.save = this.save.bind(this);
        this.print = this.print.bind(this);

        this.state = {
            patient_name:"",
            patient_sex:"",
            birthdate:"",
            clinic_history:"",
            types:[],
            type:"",
            list_notes:[],
            canPrint: false,
            medical_type:"",
        }
    }

    async componentDidMount(){
        var type = this.props.match.params.type;

        this.setState({
            medical_type: type
        });

        var lookup_type = type === 'patients' ? 'TYPES_OF_MEDICAL_NOTES' : 
                            type === 'epidemical' ? 'TYPES_OF_MEDICAL_NOTES_EPIDEMICAL' : 'TYPES_OF_MEDICAL_NOTES_OFFERING';

        var res = await lookups(lookup_type, 'true');

        if(res !== undefined){
            this.setState({types: res});
        }

        if(type === 'patients'){
            res = await petitionsApheresisValues(this.props.match.params.id);
            if(res !== undefined){
                this.setState({
                    birthdate: res.birthday !== null ? moment(res.birthday).format('DD/MM/YYYY') : "",
                    patient_name:res.names + ' ' + res.lastname1 + ' ' + res.lastname2,
                    clinic_history:res.clinic_history,
                    patient_sex: res.sex
                });
            }
        }else if(type === 'epidemical'){
            res = await donationsDonorInfo(this.props.match.params.donation_id);
            if(res !== undefined){
                this.setState({
                    birthdate: res.donor_birthday !== null ? moment(res.donor_birthday).format('DD/MM/YYYY') : "",
                    patient_name:res.donor_lastnames + ' ' + res.donor_names,
                    clinic_history:res.donation_number,
                    patient_sex: res.donor_sex
                });
            }
        }else if(type === 'cells'){
            res = await donorHcData(this.props.match.params.id, type);
            if(res !== undefined){
                this.setState({
                    birthdate: res.birthday !== null ? moment(res.birthday).format('DD/MM/YYYY') : "",
                    patient_name:res.lastnames + ' ' + res.names,
                    clinic_history:res.number,
                    patient_sex: res.sex
                });
            }
        }
        
    }

    async handleChange(e){
        var name = e.target.name;
        var value = e.target.value;

        this.setState({[name]: value, canPrint:false});

        if(name === 'type'){
            var type = this.state.medical_type === 'cells' ? 'offering' : this.state.medical_type;

            var response = await medicalNotes(type, value);
            var request;

            if(this.state.medical_type === 'patients'){
                request = await petitionMedicalNotesGet(this.props.match.params.id, value);
            }else if(this.state.medical_type === 'epidemical'){
                request = await monitoringMedicalNotes(this.props.match.params.id, value);
            }else{
                request = await offeringMedicalNotes(this.props.match.params.id, value);
            }

            
            if(response !== undefined){
                var list = [];
                response.forEach((res)=>{
                    var obj = {
                        medical_note_id: res.id,
                        name: res.name,
                        petition_id: this.props.match.params.id,
                        description:""
                    };

                    if(request !== undefined){
                        var index = request.findIndex(item => item.medical_note_id === res.id);

                        if(index !== -1){
                            obj.description = request[index].description;
                            obj.id = request[index].id;

                            this.setState({canPrint: true});
                        }
                    }

                    list.push(obj);
                });

                

                this.setState({list_notes: list});
            }
        }
    }

    changeNotes(e, i){
        var list = this.state.list_notes;

        if(e.target.value.length < 4000){
            list[i].description = e.target.value;
        }

        this.setState({list_notes: list});        
    }

    reset(e){
        e.preventDefault();

        this.props.history.goBack();
    }

    async save(e){
        e.preventDefault();

        var obj = [];

        this.state.list_notes.forEach((list)=>{
            if(list.description !== ""){
                var item = {};

                if(this.state.medical_type === 'patients'){
                    item = {
                        petition_id: list.petition_id,
                        medical_note_id: list.medical_note_id,
                        description: list.description,
                    };
                }else if(this.state.medical_type === 'epidemical'){
                    item = {
                        epidemiological_monitoring_id: list.petition_id,
                        medical_note_id: list.medical_note_id,
                        description: list.description,
                    };
                }else{
                    item = {
                        offering_cell_id: list.petition_id,
                        medical_note_id: list.medical_note_id,
                        description: list.description
                    };
                }
                
                if(list.id){
                    item.id = list.id;
                };

                obj.push(item);
            }
        });

        if(obj.length > 0){
            var res;
            if(this.state.medical_type === 'patients'){
                res = await petitionMedicalNotesPost(this.props.match.params.id, obj, this.props.waiting);
            }else if(this.state.medical_type === 'epidemical'){
                res = await monitoringMedicalNotesSave(this.props.match.params.id, obj, this.props.waiting);
            }else{
                res = await offeringMedicalNotesSave(this.props.match.params.id, obj, this.props.waiting);
            }
            
            if(res !== undefined){
                this.setState({canPrint: true});
                //this.reset(e);
            }
        }else{
            swal('Error', 'Debe agregar por lo menos una nota', 'error');
        }
    }

    async print(e){
		e.preventDefault();
		this.props.waiting.handleShow('Imprimiendo...');
        
      	var obj ={};
      	obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = this.props.match.params.id;
        obj.option = this.state.type;
      	obj.file_type = this.state.medical_type === 'patients' ? "petition_medical_notes" :
                        this.state.medical_type === 'cells' ? 'OFFERING_MEDICAL_NOTES': 'epidemi_medical_notes';
      	obj.nEtiqueta = [0];

      	var type = await this.props.getDocumentType(obj.file_type);

        if(type !== undefined){
            var document;
            if(type.print_type === 'template'){
                document = await this.props.printDocumentTemplate(obj, type.print_automatically);
            }else if(type.print_type === 'external'){
                document = await this.props.printDocumentExternal(obj, type.print_automatically);
            }
        }		

		this.props.waiting.handleClose();

	}

    async printTransfusionalRequest(e){
		e.preventDefault();
		this.props.waiting.handleShow('Imprimiendo...');
        
      	var obj ={};
      	obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = this.props.match.params.id;
        obj.option = this.state.type;
      	obj.file_type = 'TRANSFUSION_REACTION_REQUEST';
      	obj.nEtiqueta = [0];

      	var type = await this.props.getDocumentType(obj.file_type);

        if(type !== undefined){
            var document;
            if(type.print_type === 'template'){
                document = await this.props.printDocumentTemplate(obj, type.print_automatically);
            }else if(type.print_type === 'external'){
                document = await this.props.printDocumentExternal(obj, type.print_automatically);
            }
        }		

		this.props.waiting.handleClose();

	}

    render(){
        const {t} = this.props;
        var session = sessionStorage.getItem('health_facilities_name');

        return (
            <div className="col-xs-12">
                <BreadcrumbTitle
                    menu={this.state.medical_type === 'patients' ? 'Pacientes' : 'Donantes'}
                    page="Notas Médicas"
                />

                <Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_medical_notes"}  />

                <div className='col-xs-12'>
                    <fieldset>
                        <legend>Información del {this.state.medical_type === 'patients' ? 'Paciente' : 'Donante'}</legend>

                        <div className='col-xs-12'>
                            <div className='col-xs-12 col-sm-2'>
                                <span className='span-min'>Nombre del {this.state.medical_type === 'patients' ? 'Paciente' : 'Donante'}</span>
                            </div>
                            <div className='col-xs-12 col-sm-3'>
                                <span>{this.state.patient_name}</span>
                            </div>
                            <div className='col-xs-12 col-sm-2'>
                                <span className='span-min'>Fecha de Nacimiento</span>
                            </div>
                            <div className='col-xs-12 col-sm-2'>
                                <span>{this.state.birthdate}</span>
                            </div>
                        </div>
                        <div className='col-xs-12'>
                            <div className='col-xs-12 col-sm-2'>
                                <span className='span-min'>Sexo del {this.state.medical_type === 'patients' ? 'Paciente' : 'Donante'}</span>
                            </div>
                            <div className='col-xs-12 col-sm-3'>
                                <span>{this.state.patient_sex}</span>
                            </div>
                            <div className='col-xs-12 col-sm-2'>
                                <span className='span-min'>{this.state.medical_type === 'patients' ? 'No. Expediente' : 'No. Donación'}</span>
                            </div>
                            <div className='col-xs-12 col-sm-2'>
                                <span>{this.state.clinic_history}</span>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend>Nota Médica</legend>

                        <div className='col-xs-12 form-group'>
                            <div className='col-xs-12 col-sm-2'>
                                <span className='span-min'>Tipo</span>
                                <select name="type" id="type" className='form-control' value={this.state.type} onChange={(e)=>this.handleChange(e)}>
                                    <option value="">Seleccione...</option>
                                    {this.state.types.map((type, i)=>
                                        <option key={i} value={type.key}>{type.name}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        {this.state.list_notes.map((list, i)=>
                            <div className='col-xs-12 form-group'>
                                <span className='span-min'>{list.name}</span>
                                <textarea className='form-control' rows={4} 
                                    style={{width:'100%', resize:'none'}}
                                    value={list.description}
                                    onChange={(e)=>this.changeNotes(e, i)}
                                >
                                </textarea>
                            </div>
                        )}

                        
                        
                        <div className='col-xs-12 form-group' style={{textAlign:'center'}}>
                            <button className="toolIcon" disabled={!this.state.canPrint} 
                                onClick={(e)=>this.print(e)}	>
                                <SvgIcon size={40} icon={print} />
                                <div className="col-xs-12">
                                    <span>Imprimir</span>
                                </div>
                            </button>
                            {this.state.medical_type === 'patients' ?
                                <button className="toolIcon" onClick={(e)=>this.printTransfusionalRequest(e)} disabled={!this.state.canPrint} >
                                    <SvgIcon size={40} icon={print} />
                                    <div className="col-xs-12">
                                        <span>Solicitud <br/>Reacción <br/>Transfusional</span>
                                    </div>
                                </button>
                                : null
                            }
                        </div>
                        
                        <div className='col-xs-12 form-group' style={{textAlign:'center'}}>
                            <ButtonForm 
                                label="Guardar"
                                action={this.save}
                            />
                            <ButtonForm 
                                label="Cancelar"
                                action={this.reset}
                            />
                        </div>
                    </fieldset>
                </div>
            </div>
        )
    }
}

export default translate('translations') (MedicalNotes);